import { render, staticRenderFns } from "./StepConsumosAdicionales.vue?vue&type=template&id=8dcbe9d0&scoped=true&"
import script from "./StepConsumosAdicionales.vue?vue&type=script&lang=js&"
export * from "./StepConsumosAdicionales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcbe9d0",
  null
  
)

export default component.exports